 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"default~pages-cubeWork-market-market-module~pages-estimation-edit-estimate-edit-estimate-module~page~88cec6d9":"default~pages-cubeWork-market-market-module~pages-estimation-edit-estimate-edit-estimate-module~page~88cec6d9","common":"common","src-app-pages-cubeWork-job-post-job-post-module":"src-app-pages-cubeWork-job-post-job-post-module","src-app-pages-cubeWork-review-post-review-post-module":"src-app-pages-cubeWork-review-post-review-post-module","src-app-pages-cubeWork-search-job-search-job-module":"src-app-pages-cubeWork-search-job-search-job-module","src-app-pages-cubeWork-send-offer-send-offer-module":"src-app-pages-cubeWork-send-offer-send-offer-module","src-app-pages-cubeWork-view-proposals-view-proposals-module":"src-app-pages-cubeWork-view-proposals-view-proposals-module","default~pages-cubeWork-market-market-module~pages-estimation-edit-estimate-edit-estimate-module~page~989a0aa5":"default~pages-cubeWork-market-market-module~pages-estimation-edit-estimate-edit-estimate-module~page~989a0aa5","default~pages-cubeWork-market-market-module~pages-estimation-edit-estimate-edit-estimate-module~page~ebe61035":"default~pages-cubeWork-market-market-module~pages-estimation-edit-estimate-edit-estimate-module~page~ebe61035","default~pages-estimation-edit-estimate-edit-estimate-module~pages-estimation-estimation-module~pages~a2a17980":"default~pages-estimation-edit-estimate-edit-estimate-module~pages-estimation-estimation-module~pages~a2a17980","pages-videoTutorial-videoTutorial-module":"pages-videoTutorial-videoTutorial-module","default~pages-cubeWork-market-market-module~pages-estimation-edit-estimate-edit-estimate-module~page~d8a47747":"default~pages-cubeWork-market-market-module~pages-estimation-edit-estimate-edit-estimate-module~page~d8a47747","src-app-pages-cubeWork-detail-job-detail-job-module":"src-app-pages-cubeWork-detail-job-detail-job-module","src-app-pages-cubeWork-my-jobs-details-my-jobs-details-module":"src-app-pages-cubeWork-my-jobs-details-my-jobs-details-module","src-app-pages-cubeWork-myfeed2-myfeed2-module":"src-app-pages-cubeWork-myfeed2-myfeed2-module","default~pages-cubeWork-market-market-module~pages-estimation-edit-estimate-edit-estimate-module~page~4e195db3":"default~pages-cubeWork-market-market-module~pages-estimation-edit-estimate-edit-estimate-module~page~4e195db3","pages-project-management-open-rif-edit-open-rif-edit-open-rif-module":"pages-project-management-open-rif-edit-open-rif-edit-open-rif-module","src-app-pages-cubeWork-my-feed-my-feed-module":"src-app-pages-cubeWork-my-feed-my-feed-module","default~pages-cubeWork-market-market-module~pages-estimation-edit-estimate-edit-estimate-module~page~504b5891":"default~pages-cubeWork-market-market-module~pages-estimation-edit-estimate-edit-estimate-module~page~504b5891","default~pages-cubeWork-market-market-module~pages-estimation-edit-estimate-edit-estimate-module~page~e5bf5e85":"default~pages-cubeWork-market-market-module~pages-estimation-edit-estimate-edit-estimate-module~page~e5bf5e85","pages-cubeWork-market-market-module":"pages-cubeWork-market-market-module","default~pages-estimation-edit-estimate-edit-estimate-module~pages-estimation-estimation-module~src-a~b56d3e20":"default~pages-estimation-edit-estimate-edit-estimate-module~pages-estimation-estimation-module~src-a~b56d3e20","default~pages-estimation-edit-estimate-edit-estimate-module~pages-estimation-estimation-module":"default~pages-estimation-edit-estimate-edit-estimate-module~pages-estimation-estimation-module","pages-estimation-estimation-module":"pages-estimation-estimation-module","pages-estimation-edit-estimate-edit-estimate-module":"pages-estimation-edit-estimate-edit-estimate-module","default~src-app-pages-cubeWork-find-work-find-work-module~src-app-pages-cubeWork-my-proposals-my-pro~fbaf933f":"default~src-app-pages-cubeWork-find-work-find-work-module~src-app-pages-cubeWork-my-proposals-my-pro~fbaf933f","src-app-pages-cubeWork-sales-leads-sales-lead-module":"src-app-pages-cubeWork-sales-leads-sales-lead-module","src-app-pages-cubeWork-find-work-find-work-module":"src-app-pages-cubeWork-find-work-find-work-module","src-app-pages-cubeWork-my-proposals-my-proposals-module":"src-app-pages-cubeWork-my-proposals-my-proposals-module","src-app-pages-cubeWork-offer-view-offer-view-module":"src-app-pages-cubeWork-offer-view-offer-view-module","src-app-pages-cubeWork-submit-proposal-submit-proposal-module":"src-app-pages-cubeWork-submit-proposal-submit-proposal-module","src-app-pages-cubeWork-completed-jobs-completed-jobs-module":"src-app-pages-cubeWork-completed-jobs-completed-jobs-module","src-app-pages-cubeWork-cube-workmessage-cube-workmessage-module":"src-app-pages-cubeWork-cube-workmessage-cube-workmessage-module","src-app-pages-cubeWork-dashboard-talents-dashboard-talents-module":"src-app-pages-cubeWork-dashboard-talents-dashboard-talents-module","src-app-pages-cubeWork-payments-cw-payments-cw-module":"src-app-pages-cubeWork-payments-cw-payments-cw-module","src-app-pages-cubeWork-profile-talent-profile-talent-module":"src-app-pages-cubeWork-profile-talent-profile-talent-module","src-app-pages-cubeWork-reviews-reviews-module":"src-app-pages-cubeWork-reviews-reviews-module","src-app-pages-cubeWork-client-dasboard-client-dasboard-module":"src-app-pages-cubeWork-client-dasboard-client-dasboard-module","src-app-pages-cubeWork-jobs-jobs-module":"src-app-pages-cubeWork-jobs-jobs-module","pages-home-home-module":"pages-home-home-module","pages-login-create-cubeworks-user-register-cubeworks-user-module":"pages-login-create-cubeworks-user-register-cubeworks-user-module","src-app-pages-cubeWork-choose-settings-choose-settings-module":"src-app-pages-cubeWork-choose-settings-choose-settings-module","src-app-pages-cubeWork-contracts-contracts-module":"src-app-pages-cubeWork-contracts-contracts-module","src-app-pages-cubeWork-my-jobs-my-jobs-module":"src-app-pages-cubeWork-my-jobs-my-jobs-module","src-app-pages-cubeWork-reports-work-cube-reports-work-cube-module":"src-app-pages-cubeWork-reports-work-cube-reports-work-cube-module","src-app-pages-cubeWork-settings-cube-work-settings-cube-work-module":"src-app-pages-cubeWork-settings-cube-work-settings-cube-work-module","src-app-pages-cubeWork-view-job-posting-view-job-posting-module":"src-app-pages-cubeWork-view-job-posting-view-job-posting-module","canvg":"canvg","dompurify":"dompurify","html2canvas":"html2canvas"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
